import { Grid2, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "../../../app/helpers";
import {
  SelectedZoneOrWorkplaceType,
  setCurrentFloors,
  setSelectedZoneOrWorkplace,
  setSelectedByAttFilter,
  setFilterSelected
} from "../../../features/Reports/slices/report.slice";
import { fetchReport } from "../../../features/Reports/thunks/report.thunk";
import { ReportEntities } from "../../../features/Reports/typings/reports.types";
import { RootState } from "../../../app/rootReducer";
import { initialWeekdays } from "../../../features/Reports/initialWeekdays.constant";

type P = { zoneBooking: boolean };

const FloorSingleSelector: React.FC<P> = ({ zoneBooking }) => {
  const { t } = useTranslation();

  const {
    selectedLocation,
    selectedTimeframe,
    selectableEntities,
    currentFloors,
    capacitySelectedFloors,
    zoneRestrictions,
    calculateWithoutCosts,
    selectedBookingType,
    filterSelected: { selectedWeekdays }
  } = useSelector((state: RootState) => state.report);
  const {
    userInformation: { sub }
  } = useSelector((state: RootState) => state.login);
  const dispatch = useDispatch();

  return (
    <div data-testid="selectType-parent">
      <Select
        aria-labelledby="selectType" // Use aria-labelledby for better accessibility
        id="selectType"
        // purposedly the array type is chosen and considered it as unknown, to display the selected floors even when comparing floors
        value={currentFloors?.map(floor => floor.id) as unknown}
        renderValue={(selected: any) => {
          if (!selected || selected.length === 0) {
            return <span style={{ color: "#aaa" }}>{t("Location")}</span>; // Placeholder style
          }

          const selectedLocationSelect = selectableEntities?.find(
            entity => entity?.id === selectedLocation?.id
          ) as ReportEntities;

          if (selectedLocationSelect) {
            return selectedLocationSelect.floors
              ?.filter(floor => selected.includes(floor.inventoryId))
              ?.map(floor => floor.name)
              .join(", ");
          }

          return selected.join(", ");
        }}
        displayEmpty
        sx={{ width: 150, minWidth: 150, marginRight: 1 }}
        onChange={(e: SelectChangeEvent<unknown>) => {
          // purposedly considered it as unknown, to align with value type
          const value = Number(e.target.value);
          dispatch(setCurrentFloors([{ id: value, open: true }]));

          dispatch(
            setSelectedZoneOrWorkplace({
              id: [],
              name: [],
              type: SelectedZoneOrWorkplaceType.ZONE,
              open: false,
              floorInventoryId: -1,
              bookingType: undefined
            })
          );
          dispatch(
            setSelectedByAttFilter({
              id: [],
              name: [],
              type: SelectedZoneOrWorkplaceType.ZONE,
              open: false,
              floorInventoryId: -1,
              bookingType: undefined
            })
          );
          dispatch(
            setFilterSelected({
              selectedDepartmentIds: [],
              selectedWeekdays: initialWeekdays,
              selectedAttributes: []
            })
          );

          dispatch(
            fetchReport({
              id: value,
              sub: sub,
              cost: calculateWithoutCosts,
              start: selectedTimeframe?.timeframeStart as string,
              end: selectedTimeframe?.timeframeEnd as string,
              filterType: "floor",
              zoneBooking: zoneBooking,
              companyId: zoneRestrictions?.company?.id,
              zoneBookingObject: zoneRestrictions?.object?.zoneBookingObject,
              status: !capacitySelectedFloors?.some(floor => floor.id === value),
              update: false,
              bookingType: selectedBookingType ?? undefined,
              weekdays: selectedWeekdays
            })
          );
        }}
      >
        {selectableEntities
          ?.find(location => location.id === selectedLocation.id)
          ?.floors.map(floor => (
            <MenuItem key={floor.inventoryId} value={floor.inventoryId}>
              <Grid2 container justifyContent={"space-between"} alignItems={"center"}>
                {floor.name}
              </Grid2>
            </MenuItem>
          ))}
      </Select>
    </div>
  );
};

export default FloorSingleSelector;
